import { render } from "./CaseCompanyDetails.vue?vue&type=template&id=1622559d&scoped=true"
import script from "./CaseCompanyDetails.vue?vue&type=script&lang=js"
export * from "./CaseCompanyDetails.vue?vue&type=script&lang=js"

import "./CaseCompanyDetails.vue?vue&type=style&index=0&id=1622559d&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1622559d"]])

export default __exports__